import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

async function convertElementImagesToBase64(rootEl) {
    if (!rootEl) {
        return;
    }
    const images = rootEl.querySelectorAll('img');
    const tasks = [];
    images.forEach((img) => {
        if (!img.src || img.src.indexOf('data:') === 0) {
            return;
        }
        tasks.push(new Promise((resolve) => {
            const image = new Image();
            image.crossOrigin = 'anonymous';
            image.onload = function () {
                try {
                    const canvas = document.createElement('canvas');
                    canvas.width = image.naturalWidth || image.width;
                    canvas.height = image.naturalHeight || image.height;
                    const ctx = canvas.getContext('2d');
                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                    img.src = canvas.toDataURL('image/png');
                } catch (e) {
                    // 跨域图片无法转 base64 时保留原链接，由 html2canvas 尝试渲染
                }
                resolve();
            };
            image.onerror = function () {
                resolve();
            };
            const src = img.src;
            image.src = src + (src.indexOf('?') >= 0 ? '&' : '?') + '_pdf=' + Date.now();
        }));
    });
    await Promise.all(tasks);
}

/** 将 DOM 节点导出为 PDF（支持内容超出一页时分页） */
export async function exportDomToPdf(element, filename, options = {}) {
    if (!element) {
        throw new Error('export target missing');
    }
    const scale = options.scale != null ? options.scale : 2;
    const marginMm = options.marginMm != null ? options.marginMm : 0;

    await convertElementImagesToBase64(element);

    const canvas = await html2canvas(element, {
        scale,
        useCORS: true,
        backgroundColor: '#ffffff',
        logging: false,
        scrollX: 0,
        scrollY: -window.scrollY,
        width: element.scrollWidth,
        height: element.scrollHeight,
    });

    const pdf = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const contentWidth = pageWidth - marginMm * 2;
    const contentHeight = pageHeight - marginMm * 2;
    const imgWidth = contentWidth;
    const imgHeight = (canvas.height * imgWidth) / canvas.width;
    const imgData = canvas.toDataURL('image/jpeg', 0.92);

    let heightLeft = imgHeight;
    let position = marginMm;

    pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
    heightLeft -= contentHeight;

    while (heightLeft > 0) {
        position = marginMm - (imgHeight - heightLeft);
        pdf.addPage();
        pdf.addImage(imgData, 'JPEG', marginMm, position, imgWidth, imgHeight);
        heightLeft -= contentHeight;
    }

    pdf.save(filename || 'export.pdf');
}
